import React from 'react';
import { render } from 'react-dom';
import App from './App';
import './i18n'; // *** set timezone with i18next

const rootElement = document.getElementById('root');

// remove console
if (process.env.REACT_APP_FILE_NAME === '.env.production') {
    console.log = () => {};
    console.debug = () => {};
    // console.error = () => {}
}

if (rootElement === null) {
    throw new Error('No root element');
}

render(<App />, rootElement);
